// Firebase Configuration for Client Portal
// Connects to the same Firebase project as admin portal (chuko-logic)

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAEE7oH2aa7KCnS0GA3WzpOfUL43pUwz-4",
    authDomain: "chuko-logic.firebaseapp.com",
    projectId: "chuko-logic",
    storageBucket: "chuko-logic.firebasestorage.app",
    messagingSenderId: "349780562126",
    appId: "1:349780562126:web:1e1e6ee730ffb55520c09f",
    measurementId: "G-HY5FFR9CXT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
